import { FetchResourceCollectionOK } from '../types/FetchResourceCollectionOK';
import { Resource } from '../types/Resource';
import isErrorDocument from './isErrorDocument';

// eslint-disable-next-line max-len
export default <R extends Resource>(japiDocument: any): japiDocument is FetchResourceCollectionOK<R> => typeof japiDocument === 'object' && !isErrorDocument(japiDocument) && Array.isArray(japiDocument.data);
